import React from 'react';
import { Card } from './ui/card';
import { Info, Zap } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const PricingPerSquareMeter = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-black via-blue-950/20 to-slate-950 relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(59,130,246,0.05),transparent_50%)]"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-16">
              <div className="inline-block px-4 py-2 bg-purple-500/10 border border-purple-500/20 rounded-full text-purple-400 text-sm font-medium mb-4">
                Transparente Preise
              </div>
              <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
                Preise ab CHF / m²
              </h2>
              <p className="text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
                Unsere Preise richten sich nach Wohnungsgröße, Zustand, Leerstand oder Möblierung sowie dem gewünschten Aufwand. Für leere Wohnungen mit Standard-Weißanstrich bieten wir besonders attraktive Fixpreise.
              </p>
            </div>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <ScrollReveal delay={0.2}>
              <Card className="p-10 bg-gradient-to-br from-emerald-500/10 via-green-500/5 to-transparent backdrop-blur-xl border-2 border-emerald-500/30 shadow-2xl shadow-emerald-500/10 hover:shadow-emerald-500/20 transition-all duration-500 hover:scale-105 relative overflow-hidden group">
                <div className="absolute top-0 right-0 w-32 h-32 bg-emerald-500/10 rounded-full blur-3xl group-hover:w-64 group-hover:h-64 transition-all duration-700"></div>
                <div className="relative z-10">
                  <div className="flex items-center gap-2 text-emerald-400 font-semibold text-lg mb-4">
                    <Zap className="w-5 h-5" />
                    Leere Wohnungen
                  </div>
                  <div className="text-6xl font-bold text-white mb-3">
                    CHF 18-25
                  </div>
                  <div className="text-slate-300 text-xl mb-4">pro m²</div>
                  <p className="text-slate-400 text-lg">
                    Ideal für Wohnungsübergabe beim Auszug
                  </p>
                </div>
              </Card>
            </ScrollReveal>

            <ScrollReveal delay={0.3}>
              <Card className="p-10 bg-gradient-to-br from-blue-500/10 via-indigo-500/5 to-transparent backdrop-blur-xl border-2 border-blue-500/30 shadow-2xl shadow-blue-500/10 hover:shadow-blue-500/20 transition-all duration-500 hover:scale-105 relative overflow-hidden group">
                <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/10 rounded-full blur-3xl group-hover:w-64 group-hover:h-64 transition-all duration-700"></div>
                <div className="relative z-10">
                  <div className="text-blue-400 font-semibold text-lg mb-4">Möblierte Wohnungen</div>
                  <div className="text-6xl font-bold text-white mb-3">
                    auf Anfrage
                  </div>
                  <div className="text-slate-300 text-xl mb-4">nach Aufwand</div>
                  <p className="text-slate-400 text-lg">
                    Preis abhängig von Abdeckarbeiten
                  </p>
                </div>
              </Card>
            </ScrollReveal>
          </div>

          <ScrollReveal delay={0.4}>
            <Card className="p-8 bg-gradient-to-r from-blue-500/10 to-purple-500/10 border-l-4 border-blue-500 backdrop-blur-xl">
              <div className="flex gap-4">
                <Info className="w-7 h-7 text-blue-400 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-slate-300 text-lg leading-relaxed">
                    Den genauen Fixpreis erhalten Sie schnell und unverbindlich per WhatsApp nach Fotos oder m²-Angabe.
                  </p>
                </div>
              </div>
            </Card>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default PricingPerSquareMeter;